/**
 * Sets Sentry user context when user logs in/out.
 * This component should be rendered inside UserProvider.
 */
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useUser } from '../auth/useUser';

export function SentryUserContext() {
    const { isAuthenticated, user, isGuest } = useUser();

    useEffect(() => {
        if (isAuthenticated && user) {
            // Set user context for authenticated users
            Sentry.setUser({
                id: user.sub, // Auth0 user ID
                email: user.email,
                username: user.name || user.nickname,
            });
        } else if (isGuest) {
            // Set minimal context for guests
            Sentry.setUser({
                id: 'guest',
            });
        } else {
            // Clear user context when logged out
            Sentry.setUser(null);
        }
    }, [isAuthenticated, user, isGuest]);

    return null; // This component renders nothing
}
